import {
  Autocomplete,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";

// helper
import ReactSwal from "../../helper/AlertHelper";
import { storeTypeList } from "../../helper/GlobalValueHelper";
import { checkPermission } from "../../helper/PermissionHelper";
import { pageName } from "../../reducers/commonSlice";
import { user } from "../../reducers/userSlice";

// icons
import MoreVertIcon from "@mui/icons-material/MoreVert";

// components
import DebugLogger from "../DebugLogger";
import UpdaterInfo from "../UpdaterInfo";

// api
import { InventoryApi } from "../../api/InventoryApi";

export default function BaseInfo({ data, setData, onDelete }) {
  const { t, i18n } = useTranslation();
  const [InventoryList, setInventoryList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [haveDeletePermission, setHaveDeletePermission] = useState(false);
  const currentUser = useSelector(user);
  const currentPage = useSelector(pageName);

  useEffect(() => {
    fetchInventory();
  }, []);

  useEffect(() => {
    const deletePermission = checkPermission(currentUser, currentPage, "delete");

    setHaveDeletePermission(deletePermission);
  }, [currentUser, currentPage]);

  const fetchInventory = async () => {
    const response = await InventoryApi.list(1, -1, []);
    setInventoryList(response.data);
  };

  const onChangeInventory = value => {
    setData({ ...data, inventoryId: value ? value.id : null });
  };

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const showDeleteConfirm = () => {
    ReactSwal.fire({
      title: t("error.warning"),
      text: t("error.delete_confirm"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("layout.ok"),
      cancelButtonText: t("layout.cancel"),
    }).then(result => {
      if (result.isConfirmed) {
        onDelete();
      }
    });
  };

  return (
    <Card variant="outlined">
      <CardHeader
        title={data.id ? t("store.edit_store") : t("store.new_store")}
        action={
          onDelete && haveDeletePermission ? (
            <Box>
              <IconButton onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem onClick={showDeleteConfirm}>
                  <Typography color={"error"}>{t("layout.delete")}</Typography>
                </MenuItem>
              </Menu>
            </Box>
          ) : (
            <Box />
          )
        }
      />

      <CardContent>

        <DebugLogger title={"Stores"} data={data} hidden={true} />
        <Stack spacing={2}>
          <TextField
            value={data.name}
            onChange={event => setData({ ...data, name: event.target.value })}
            required
            fullWidth
            autoFocus
            label={t("layout.name")}
          />



          <TextField
            value={data.code || ""}
            onChange={event => setData({ ...data, code: event.target.value })}
            fullWidth
            label={t("layout.code")}
          />

          {/* <Autocomplete
            filterSelectedOptions
            isOptionEqualToValue={(opt, value) => {
              return opt.value === value.value;
            }}
            value={data.type}
            options={storeTypeList}
            getOptionLabel={opt => (i18n.language === "en" ? opt.nameEn : opt.nameZh)}
            onChange={(event, newValue) => {
              setData({
                ...data,
                type: newValue,
              });
            }}
            renderInput={params => <TextField required {...params} label={t("layout.type")} />}
          /> */}

          <TextField
            value={data.phoneNumber}
            onChange={event => setData({ ...data, phoneNumber: event.target.value })}
            fullWidth
            label={t("layout.phone_number")}
          />

          <Autocomplete
            filterSelectedOptions
            isOptionEqualToValue={(opt, value) => {
              return opt.id === value.id;
            }}
            value={InventoryList.find(x => x.id === data.inventoryId) || null}
            options={InventoryList}
            getOptionLabel={opt => opt.name}
            onChange={(event, newValue) => {
              onChangeInventory(newValue);
            }}
            renderInput={params => (
              <TextField required {...params} label={t("layout.inventory")} />
            )}
          />

          <TextField
            fullWidth
            label={t("layout.address")}
            multiline
            value={data.address}
            onChange={event => {
              setData({ ...data, address: event.target.value });
            }}
            rows={4}
          />

          <UpdaterInfo data={data} />
        </Stack>

      </CardContent>

      <CardActions sx={{ justifyContent: "space-between", px: 2 }}></CardActions>
    </Card>
  );
}
